<div class="content-1920">
  <div class="content-padding margin-top-small">
    <button class="btn-small" type="button" routerLink="/integrations">
      &larr; Back to integrations
    </button>

    @if (provider) {
    <h2 class="margin-top-small">{{ providerLabel }} farms &amp; fields</h2>
    <p class="muted">
      Link {{ providerLabel }} farms and fields to your Harvest Mate farms and
      blocks. Machinery linkage is managed from the {{ providerLabel }}
      connection page.
    </p>

    <app-farm-link-panel
      [provider]="provider"
      [providerLabel]="providerLabel"
    ></app-farm-link-panel>

    <app-field-link-panel
      [provider]="provider"
      [providerLabel]="providerLabel"
    ></app-field-link-panel>
    }
  </div>
</div>
